export default "__VITE_ASSET__5c2789b5__"